export const ontimeSwitch = {
  track: {
    background: '#2d2d2d', // $gray-1100
    border: '1px solid transparent',
    _checked: {
      background: '#2B5ABC', // $blue-700
    },
    _focus: {
      border: '1px solid #578AF4', // $blue-500
    },
  },
};
